// Select options on a CID Forms document field (the prefill schema's `options`)
// are plain strings, or { value, label } when the stored value is a fixed code
// with wording that may change (the Landlord's LOU SST choice). Mirrors the
// server's libraryDoc.service.js, which applies the same matching on render.

export const selectOptions = (options) =>
  (options || []).map((o) => (o && typeof o === 'object' ? o : { value: o, label: o }));

// The option a handed-over value names — by value or label, ignoring case and
// spacing — as its stored value; undefined when it names none, so a Copilot
// card can never show one choice while the letter prints another.
export const matchOption = (options, v) => {
  const want = String(v).trim().toLowerCase();
  const hit = selectOptions(options).find((o) => [o.value, o.label].some((x) => String(x).trim().toLowerCase() === want));
  return hit ? hit.value : undefined;
};

// A field with `showIf: { key, value }` is shown only while that other field
// holds `value`; a blank there counts as its schema starting value (the sale
// LOUs' "% of price / fixed RM" fee choice). The server prints only the figure
// the choice names, so a hidden field's leftover value is harmless.
export const fieldShown = (f, values, fields) => {
  if (!f.showIf) return true;
  const cur = values[f.showIf.key] ?? (fields || []).find((x) => x.key === f.showIf.key)?.value;
  return cur === f.showIf.value;
};

// A prefill (a Copilot card) that hands a figure behind a `showIf` but not the
// choice that reveals it — only `fee_amount_rm`, say — would leave that choice
// at its preset, the figure hidden and the letter printing a blank. So the
// controlling field takes the value that shows what was handed, unless it was
// handed itself or the handed fields behind it disagree (both % and RM).
// `handedKeys` are the keys actually applied from the prefill; mutates `values`.
export const revealHanded = (fields, values, handedKeys) => {
  const want = {};
  for (const f of fields || []) {
    if (!f.showIf || !handedKeys.has(f.key) || handedKeys.has(f.showIf.key)) continue;
    const k = f.showIf.key;
    want[k] = k in want && want[k] !== f.showIf.value ? null : f.showIf.value;
  }
  for (const [k, v] of Object.entries(want)) if (v !== null) values[k] = v;
  return values;
};
